<template>
  <div class="home">
    <view-list :list="list" type="photo" :page="page" :total="total" @loadmore="loadmore" @gallerySort="gallerySort"></view-list>
    <Footer></Footer>
  </div>
</template>

<script>
import Session from '../utils/session'
import Footer from '@/components/footer.vue'
import API from '@/service/API'
import ViewList from '@/components/viewList'
export default {
  name: 'Home',
  data(){
    return {
      list: [],
      total: 0,
      page: 1,
      hasNext: false,
      ordering: '-create_time,-vote_num',
    }
  },
  components: {
    ViewList,
    Footer
  },
  watch: {
    '$route': function() {
      this.getList()
    }
  },
  mounted(){
    this.getList()
    document.title = this.$route.meta.title
  },
  activated(){
    const scrollTop = this.$route.meta.scrollTop;
    if (scrollTop) {
      window.scrollTo(0, scrollTop)
    }
  },
  methods:{
    gallerySort(flag){
      if(flag){
        this.$data.ordering = 'create_time,vote_num';
      } else {
        this.$data.ordering = '-create_time,-vote_num';
      }
      this.$data.page = 1;
      this.$data.list = [];
      this.getList();
    },
    getList(){
      let params = {
        album: Session.get("albums"),
        page: this.$data.page,
        // ordering: this.$data.ordering
      }
      API.getList(params).then( res => {
        this.$data.hasNext = res.hasNext;
        this.$data.list = this.$data.list.concat(res.list)
        this.$data.total = res.total
      })
    },
    loadmore(){
      if(this.$data.hasNext){
        this.$data.page++
        this.getList()
      }
    }
  }
}
</script>